// Cart page specific functionality
// Note: getCookie/setCookie are already defined globally in cart.js and delivery-drawer-functions.js

// Use getCookie helper (already defined globally)
const getCartCookie = (name) => {
  if (typeof getCookie === 'function') return getCookie(name);
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Store encoded in the reserved slot id ("YYYYMMDD-STORE-TYPE-ZONE-START-END").
// Prefers getStoreFromUniqueWindow from delivery-drawer-functions.js; the tiny
// parser is duplicated here because load order on the cart page isn't guaranteed.
const getSlotStore = (uniqueWindow) => {
  if (typeof getStoreFromUniqueWindow === 'function') return getStoreFromUniqueWindow(uniqueWindow);
  const parts = String(uniqueWindow || '').split('-');
  return parts.length >= 2 && /^\d+$/.test(parts[1]) ? parts[1] : null;
};

window.addEventListener('DOMContentLoaded', function() {
  // Check if URL contains edit-delivery param
  if (window.location.href.indexOf("/cart?=edit-delivery") !== -1) {
    console.log("Opening delivery drawer from URL param");
    if (typeof theme !== 'undefined' && theme.promptForDeliveryType) {
      theme.promptForDeliveryType();
    }
    if (typeof updateDeliveryDrawer === 'function') {
      updateDeliveryDrawer();
    }
  }
});

cartDeliveryDetails();

// Silently heal the cart's order attributes if they disagree with the current
// cookies (e.g. a reservation cancelled elsewhere left stale attributes, or a
// reservation was made while a cart write failed).
fetch("/cart.js")
  .then(response => response.json())
  .then(cartData => {
    if (typeof syncDeliveryAttributesToCart !== 'function') return;
    const expiresTime = getCartCookie("delivery_expires_time");
    const hasReservation = expiresTime && parseInt(expiresTime, 10) > new Date().getTime();
    const cookieStore = hasReservation ? (getCartCookie("picking_store") || "") : "";
    const cartStore = (cartData.attributes && cartData.attributes.picking_store) || "";
    if (String(cookieStore) !== String(cartStore)) {
      console.log(`Cart attributes out of sync with cookies (cart: "${cartStore}", cookies: "${cookieStore}") - syncing`);
      syncDeliveryAttributesToCart().catch(attrError => {
        console.error('Cart attribute sync failed:', attrError);
      });
    }
  })
  .catch(() => {});

const cartTotalsWrapper = document.querySelector(".cart-totals-wrapper");
if (cartTotalsWrapper) {
  cartTotalsWrapper.classList.add("loading-delivery");
}

// Liquor receiving checkbox
const liquorReceiving = document.getElementById("liquor_receiving");
if (liquorReceiving) {
  liquorReceiving.addEventListener("click", function () {
    const liquorNominate = document.getElementById("liquor_receiving_nominate");
    if (liquorNominate) {
      liquorNominate.style.display = liquorNominate.style.display === "none" ? "block" : "none";
    }
  });
}

// Leave unattended checkbox
const leaveUnattended = document.getElementById("leave_unattended");
if (leaveUnattended) {
  leaveUnattended.addEventListener("click", function () {
    const input = document.querySelector("[name='attributes[leave_unattended]']");
    if (input) {
      input.value = this.checked ? 1 : 0;
    }
  });
}

// No replacements checkbox
const noReplacements = document.getElementById("no_replacements");
if (noReplacements) {
  noReplacements.addEventListener("click", function () {
    const input = document.querySelector("[name='attributes[no_replacements]']");
    if (input) {
      input.value = this.checked ? 1 : 0;
    }
  });
}

// Show delivery reservation pop-up if sent back from checkout due to Uber address error
const action = new URL(location.href).searchParams.get("action");
if (action == "uberChooseNewDeliveryType") {
  if (typeof theme !== 'undefined' && theme.promptForDeliveryType) {
    theme.promptForDeliveryType();
  }
}

// Cart delivery details function
function cartDeliveryDetails() {
  const deliveryExpiresTime = getCartCookie("delivery_expires_time");
  
  if (deliveryExpiresTime) {
    // Final safety check (mirrors getDeliveryAttributesFromCookies): the
    // reserved slot id encodes its store and is the reservation's ground
    // truth. If the picking_store cookie disagrees (e.g. a stale URL location
    // filter stomped storage after the reservation - order HF#2086176), the
    // checkout hidden inputs must carry the SLOT's store, otherwise checkout
    // stamps the mismatch onto the order. Click & collect is excluded (keyed
    // by delivery_cc_store instead).
    let pickingStoreForCheckout = getCartCookie("picking_store");
    const uniqueWindowCookie = getCartCookie("delivery_unique_window");
    if (getCartCookie("delivery_type") !== "M" && !getCartCookie("delivery_cc_store")) {
      const slotStore = getSlotStore(uniqueWindowCookie);
      if (slotStore && pickingStoreForCheckout !== slotStore) {
        console.error(`⚠️ picking_store cookie (${pickingStoreForCheckout || "empty"}) disagrees with reserved slot ${uniqueWindowCookie} (store ${slotStore}) - using the slot's store for checkout attributes and healing storage.`);
        pickingStoreForCheckout = slotStore;
        if (typeof syncPickingStoreStorage === 'function') {
          syncPickingStoreStorage(slotStore);
        } else if (typeof setCookie === 'function') {
          setCookie("picking_store", slotStore, 365);
        }
      }
    }

    // Set order attributes
    const attributes = {
      'delivery_date': getCartCookie("delivery_date"),
      'delivery_run': getCartCookie("delivery_run"),
      'picking_store': pickingStoreForCheckout,
      'courier': getCartCookie("delivery_courier"),
      'unique_window': getCartCookie("delivery_unique_window"),
      'delivery_type': getCartCookie("delivery_type"),
      'delivery_cc_store': getCartCookie("delivery_cc_store"),
      'postcode': getCartCookie("postcode"),
      'local_delivery_request': getCartCookie("delivery_time")
    };

    // Set all attribute inputs. Always write the value - clearing inputs whose
    // cookie is missing - so e.g. a C&C -> delivery switch cannot leave a stale
    // delivery_cc_store in the form.
    Object.keys(attributes).forEach(key => {
      const input = document.querySelector(`input[name='attributes[${key}]']`);
      if (input) {
        input.value = attributes[key] || "";
      }
    });

    const deliveryType = getCartCookie("delivery_type");
    const deliveryStoreStrong = document.querySelector("#delivery-store strong");
    const deliverySuburbStrong = document.querySelector("#delivery-suburb strong");
    
    if (deliveryStoreStrong) {
      if (deliveryType === "M") {
        deliveryStoreStrong.innerHTML = "Pickup store:";
      } else if (deliveryType === "EX") {
        deliveryStoreStrong.innerHTML = "Fulfilled by:";
      }
    }

    if (deliverySuburbStrong) {
      deliverySuburbStrong.innerHTML = deliveryType === "M" ? "Pickup location:" : "Delivery area:";
    }

    // Show delivery reservation details
    const deliveryDateStr = getCartCookie("delivery_date");
    if (deliveryDateStr) {
      const deliveryDate = new Date(deliveryDateStr);
      const formattedDeliveryDate = deliveryDate.toLocaleDateString("en-AU", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      const deliverySuburb = document.getElementById("delivery_suburb");
      const deliveryPostcode = document.getElementById("delivery_postcode");
      const deliveryDateText = document.getElementById("delivery_date_text");
      const deliveryTypeText = document.getElementById("delivery_type_text");
      const deliveryTimeText = document.getElementById("delivery_time_text");
      
      if (deliverySuburb) deliverySuburb.innerHTML = getCartCookie("suburb") || "";
      if (deliveryPostcode) {
        const postcode = getCartCookie("postcode");
        deliveryPostcode.innerHTML = postcode ? postcode : "";
      }
      if (deliveryDateText) deliveryDateText.innerHTML = formattedDeliveryDate;
      if (deliveryTypeText) deliveryTypeText.innerHTML = getCartCookie("delivery_type_long") || "";
      if (deliveryTimeText) deliveryTimeText.innerHTML = getCartCookie("delivery_time_short") || "";
    }
    
    // Get picking store and populate store name (the healed value, so the
    // displayed store always matches what checkout will be sent).
    const cartPickingStore = pickingStoreForCheckout;
    let cartStoreName = "Store not found";
    
    if (cartPickingStore && typeof storeMatrix !== 'undefined') {
      const storeId = parseInt(cartPickingStore, 10);
      cartStoreName = storeMatrix[0][storeId] || cartStoreName;
    }

    const selectedStoreText = document.getElementById("selected_store_text");
    const deliveryCartTable = document.getElementById("delivery_cart_table");
    
    if (selectedStoreText) selectedStoreText.innerHTML = cartStoreName;
    if (deliveryCartTable) deliveryCartTable.style.display = "flex";

    // Show calculate delivery charge button
    const calcDeliveryCharge = document.querySelectorAll(".calc-delivery-charge");
    calcDeliveryCharge.forEach(el => el.style.display = "block");
  } else {
    // Show please reserve delivery time msg
    const reserveMsg = document.getElementById("reserve_delivery_msg");
    const deliveryCartTable = document.getElementById("delivery_cart_table");
    
    if (reserveMsg) reserveMsg.style.display = "block";
    if (deliveryCartTable) deliveryCartTable.style.display = "none";
  }
}
